import { OTHERWORLD_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/otherworldBackdrops';
import { stoneBiome } from '../biomeArchetypes';
import { ATMOSPHERE_PALETTE as P } from '../palette';

/** Cave (crystal caverns / grotto) — cool crystal glow, blue motes, a crystal light bed,
 *  crystal shimmer, and distant crystal spires. */
export const CAVE = stoneBiome({
  id: 'cave',
  sky: { from: 0x05080f, to: 0x163446 },
  motes: { colors: [P.crystal, P.mushroomBlue, P.cyan], count: 16, sizeMin: 6, sizeMax: 14, driftPx: 16, periodMinMs: 8000, periodMaxMs: 16000, alphaMin: 0.2, alphaMax: 0.7 },
  glow: {
    blobs: [
      { color: P.crystal, atX: 0.25, atY: 0.7, size: 420, alpha: 0.1 },
      { color: P.mushroomBlue, atX: 0.78, atY: 0.4, size: 380, alpha: 0.09 },
    ],
    breathe: { periodMs: 6000, min: 0.65, max: 1.35 },
  },
  lightField: { palette: [P.crystal, P.mushroomBlue, P.cyan], count: 12, sizeMin: 80, sizeMax: 200, alphaMin: 0.05, alphaMax: 0.18, driftRadius: 40, periodMinMs: 9000, periodMaxMs: 16000 },
  flicker: { color: P.crystal, size: 200, baseAlpha: 0.1, flickerAmp: 0.07, hzMin: 1, hzMax: 3, anchors: [{ atX: 0.25, atY: 0.65 }, { atX: 0.78, atY: 0.4 }, { atX: 0.55, atY: 0.55 }] },
  extraLayers: [
    // Bats: schoolingMotes as a flock of dark, fast-moving shapes that
    // scatter on combat (startle). Cross-biome reuse of the schooling
    // motes kind — the same effect that powers sunken_drift's fish.
    {
      kind: 'schoolingMotes',
      count: 18, schools: 2,
      palette: [0x1a1a2a, 0x0a0a18],
      sizeMin: 4, sizeMax: 8,
      speed: 35,
      cohesion: 0.25, alignment: 0.35, separation: 0.6,
      bandYMin: 0.1, bandYMax: 0.5,
      startle: true,
    },
  ],
  parallax: [
    { svg: OTHERWORLD_BACKDROPS.cave.far, shape: 'spires', color: 0x2a4054, speed: 0.04, height: 400, alpha: 0.7, detail: 0.9, sway: { ampPx: 10, periodMs: 32000 } },
    { svg: OTHERWORLD_BACKDROPS.cave.mid, shape: 'spires', color: 0x182c3c, speed: 0.10, height: 280, alpha: 0.84, detail: 1.3 },
    { svg: OTHERWORLD_BACKDROPS.cave.near, shape: 'spires', color: 0x0e1a26, speed: 0.18, height: 180, alpha: 0.94, detail: 1.1 },
  ],
  closer: { grade: { top: 0x46586e, bottom: 0x141c28, strength: 0.13 } },
});
